import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getInvoicesRes: null,
    getInvoiceByIdRes: null,
    addPaymentRes: null,
    cancelInvoiceRes: null,
    updateLineItemsRes: null,
    applyVoucherRes: null,
    removeVoucherRes: null,
    setVoucherSerialRes: null,
};

const slice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        // Get invoices list
        getInvoicesRequest: (state) => {
            state.loading = true;
        },
        getInvoicesSuccess: (state, action) => {
            state.loading = false;
            state.getInvoicesRes = action.payload;
        },
        getInvoicesFailure: (state, action) => {
            state.loading = false;
            state.getInvoicesRes = action.payload;
        },
        resetGetInvoices: (state) => {
            state.getInvoicesRes = null;
        },

        // Get invoice by ID
        getInvoiceByIdRequest: (state) => {
            state.loading = true;
        },
        getInvoiceByIdSuccess: (state, action) => {
            state.loading = false;
            state.getInvoiceByIdRes = action.payload;
        },
        getInvoiceByIdFailure: (state, action) => {
            state.loading = false;
            state.getInvoiceByIdRes = action.payload;
        },
        resetGetInvoiceById: (state) => {
            state.getInvoiceByIdRes = null;
        },

        // Add payment
        addPaymentRequest: (state) => {
            state.loading = true;
        },
        addPaymentSuccess: (state, action) => {
            state.loading = false;
            state.addPaymentRes = action.payload;
        },
        addPaymentFailure: (state, action) => {
            state.loading = false;
            state.addPaymentRes = action.payload;
        },
        resetAddPayment: (state) => {
            state.addPaymentRes = null;
        },

        // Cancel invoice
        cancelInvoiceRequest: (state) => {
            state.loading = true;
        },
        cancelInvoiceSuccess: (state, action) => {
            state.loading = false;
            state.cancelInvoiceRes = action.payload;
        },
        cancelInvoiceFailure: (state, action) => {
            state.loading = false;
            state.cancelInvoiceRes = action.payload;
        },
        resetCancelInvoice: (state) => {
            state.cancelInvoiceRes = null;
        },

        // Update line items
        updateLineItemsRequest: (state) => {
            state.loading = true;
        },
        updateLineItemsSuccess: (state, action) => {
            state.loading = false;
            state.updateLineItemsRes = action.payload;
        },
        updateLineItemsFailure: (state, action) => {
            state.loading = false;
            state.updateLineItemsRes = action.payload;
        },
        resetUpdateLineItems: (state) => {
            state.updateLineItemsRes = null;
        },

        // Apply voucher
        applyVoucherRequest: (state) => {
            state.loading = true;
        },
        applyVoucherSuccess: (state, action) => {
            state.loading = false;
            state.applyVoucherRes = action.payload;
        },
        applyVoucherFailure: (state, action) => {
            state.loading = false;
            state.applyVoucherRes = action.payload;
        },
        resetApplyVoucher: (state) => {
            state.applyVoucherRes = null;
        },

        // Remove voucher
        removeVoucherRequest: (state) => {
            state.loading = true;
        },
        removeVoucherSuccess: (state, action) => {
            state.loading = false;
            state.removeVoucherRes = action.payload;
        },
        removeVoucherFailure: (state, action) => {
            state.loading = false;
            state.removeVoucherRes = action.payload;
        },
        resetRemoveVoucher: (state) => {
            state.removeVoucherRes = null;
        },

        // Government health-voucher serial (Guyana voucher submission)
        setVoucherSerialRequest: (state) => {
            state.loading = true;
        },
        setVoucherSerialSuccess: (state, action) => {
            state.loading = false;
            state.setVoucherSerialRes = action.payload;
        },
        setVoucherSerialFailure: (state, action) => {
            state.loading = false;
            state.setVoucherSerialRes = action.payload;
        },
        resetSetVoucherSerial: (state) => {
            state.setVoucherSerialRes = null;
        },
    }
});

export const {
    getInvoicesRequest, getInvoicesSuccess, getInvoicesFailure, resetGetInvoices,
    getInvoiceByIdRequest, getInvoiceByIdSuccess, getInvoiceByIdFailure, resetGetInvoiceById,
    addPaymentRequest, addPaymentSuccess, addPaymentFailure, resetAddPayment,
    cancelInvoiceRequest, cancelInvoiceSuccess, cancelInvoiceFailure, resetCancelInvoice,
    updateLineItemsRequest, updateLineItemsSuccess, updateLineItemsFailure, resetUpdateLineItems,
    applyVoucherRequest, applyVoucherSuccess, applyVoucherFailure, resetApplyVoucher,
    removeVoucherRequest, removeVoucherSuccess, removeVoucherFailure, resetRemoveVoucher,
    setVoucherSerialRequest, setVoucherSerialSuccess, setVoucherSerialFailure, resetSetVoucherSerial,
} = slice.actions;

export default slice.reducer;
